(() => {
  if (customElements.get('tuokus-details-preview')) return;

  class TuokusDetailsPreview extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.tuokus-details-preview__content');
      this.viewport = this.querySelector('.tuokus-details-preview__viewport');
      this.button = this.querySelector('.tuokus-details-preview__toggle');
      if (!this.content || !this.viewport || !this.button) return;
      this.expanded = this.dataset.expanded === 'true';
      this.refresh = this.measure.bind(this);
      this.toggle = () => {
        const top = this.getBoundingClientRect().top;
        const returnY = top + window.scrollY - 100;
        const returning = this.expanded && top < 0;
        this.expanded = !this.expanded;
        this.render();
        if (returning) {
          this.closest('details')?.querySelector('summary')?.focus({ preventScroll: true });
          window.scrollTo({ top: Math.max(0, returnY), behavior: 'auto' });
        }
      };
      this.revealFocus = event => {
        if (this.expanded || this.dataset.overflow !== 'true') return;
        const target = event.target.getBoundingClientRect();
        const preview = this.viewport.getBoundingClientRect();
        if (this.viewport.scrollTop > 0 || target.bottom > preview.bottom - 32 || target.top < preview.top) {
          this.expanded = true;
          this.render();
          this.viewport.scrollTop = 0;
          event.target.scrollIntoView?.({ block: 'nearest', behavior: 'auto' });
        }
      };
      this.button.addEventListener('click', this.toggle);
      this.content.addEventListener('focusin', this.revealFocus);
      this.content.addEventListener('load', this.refresh, true);
      this.details = this.closest('details');
      this.details?.addEventListener('toggle', this.refresh);
      window.addEventListener('resize', this.refresh);
      if (typeof ResizeObserver === 'function') {
        this.observer = new ResizeObserver(this.refresh);
        this.observer.observe(this.content);
      }
      this.measure();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggle);
      this.content?.removeEventListener('focusin', this.revealFocus);
      this.content?.removeEventListener('load', this.refresh, true);
      this.details?.removeEventListener('toggle', this.refresh);
      window.removeEventListener('resize', this.refresh);
      this.observer?.disconnect();
    }

    measure() {
      const height = Math.max(this.content.scrollHeight, this.content.getBoundingClientRect().height);
      if (!height) return;
      const limit = parseFloat(getComputedStyle(this).getPropertyValue('--tuokus-details-limit')) || 720;
      this.dataset.overflow = String(height > limit + 8);
      this.render();
    }

    render() {
      this.dataset.expanded = String(this.expanded);
      this.button.hidden = this.dataset.overflow !== 'true';
      this.button.setAttribute('aria-expanded', String(this.expanded));
      this.button.textContent = this.expanded ? this.button.dataset.lessLabel : this.button.dataset.moreLabel;
      this.viewport.scrollTop = 0;
    }
  }

  customElements.define('tuokus-details-preview', TuokusDetailsPreview);
})();
